import { render } from "./PreschoolAcademicAssignments.vue?vue&type=template&id=ed8be28c&ts=true"
import script from "./PreschoolAcademicAssignments.vue?vue&type=script&lang=ts"
export * from "./PreschoolAcademicAssignments.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__